import { render } from "./UserRole.vue?vue&type=template&id=dc005aa8&scoped=true"
import script from "./UserRole.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRole.vue?vue&type=script&setup=true&lang=js"

import "./UserRole.vue?vue&type=style&index=0&id=dc005aa8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc005aa8"],['__file',"src/pages/users/UserRole.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dc005aa8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dc005aa8', __exports__)) {
    console.log('reload')
    api.reload('dc005aa8', __exports__)
  }
  
  module.hot.accept("./UserRole.vue?vue&type=template&id=dc005aa8&scoped=true", () => {
    console.log('re-render')
    api.rerender('dc005aa8', render)
  })

}


export default __exports__